import { Key } from '@/icons'
import { Badge, Flex } from '@chakra-ui/react'
import type { UserRole } from 'BrokerTsLib/src/dtos'

export const UserRolesBadge = ({ roles }: { roles: { role: UserRole, roleName: string }[] }) =>
  roles.length > 0 && <Badge colorScheme={'orange'} width={'fit-content'} gap={1} display={'flex'} alignItems={'center'} fontWeight={'medium'}><Key boxSize={4} /> {roles.map(x => x.roleName).join(', ')}</Badge>
